import { IAppState } from '../../common/state';

export function getResidentialStatus(state: IAppState) {
  return state.newbuildingInformation?.residentialStatus;
}
